// Derived view only: don't overwrite the historical financials record on page load.
export function invoicePaymentView(project) {
 const original=project?.financials?.[0];
 if(!original)return {financials:null,extra:[],credit:0,review:false};
 const f={...original},docs=[...new Map((project.linkedInvoices||[]).map(d=>[d.id,d])).values()];
 const used=new Set([f.invoice_no_1,f.invoice_no_2].filter(Boolean));
 const free=docs.filter(d=>!used.has(d.number));
 for(const slot of [1,2]){
  // Never replace an unmatched manual invoice, date or payment with a guess.
  if(!f['invoice_no_'+slot]&&!f['invoice_date_'+slot]&&!Number(f['paid_amount_'+slot])&&free.length){
   const d=free.shift(); f['invoice_no_'+slot]=d.number; used.add(d.number);
  }
 }
 let credit=0,review=false,changed=false;
 const extra=[];
 for(const d of docs){
  const a=d.allocations?.find(a=>a.project_id===project.id);
  const slot=f.invoice_no_1===d.number?1:f.invoice_no_2===d.number?2:null;
  if(slot){
   f['invoice_date_'+slot]=d.date; f['invoice_due_date_'+slot]=d.due;
   if(a?.net_pence!=null)f['invoice_amount_'+slot]=a.net_pence/100;
   if(a?.known){f['paid_amount_'+slot]=a.paid_net_pence/100;credit+=a.credited_net_pence/100;changed=true;}
   else review=true;
  }else{extra.push({...d,allocation:a});if(a?.known)credit+=a.credited_net_pence/100;else review=true;}
 }
 // Preserve aggregate-only legacy receipts when there is no verified allocation.
 if(changed)f.paid_amount=Number(f.paid_amount_1||0)+Number(f.paid_amount_2||0);
 return {financials:f,extra,credit,review};
}
